import React from 'react';
// helpers/constants
import * as G from '../../helpers';
// ui
import TextComponent from '../text';
import { BoxHovered } from '../../ui';
//////////////////////////////////////////////////

export const ActionBox = ({
  text,
  color,
  action,
  maxWidth,
  boxStyles,
  hoverColor,
}) => (
  <BoxHovered
    cursor='pointer'
    onClick={action}
    maxWidth={maxWidth}
    hoverFontWeight='bold'
    hoverTextDecoration='underline'
    color={color || G.getTheme('colors.light.blue')}
    hoverColor={hoverColor || G.getTheme('colors.dark.blue')}
    {...G.spreadUiStyles(boxStyles)}
  >
    <TextComponent
      display='block'
      maxWidth={maxWidth}
      withEllipsis={true}
    >
      {text}
    </TextComponent>
  </BoxHovered>
);
